export class BotLanguage {

    botLanguageId: any;
	botLanguageStatus: any;
	language: any;

}